
export class PayrollComponentsDto {
    employeeId: number;
    basic: number;
    hraAmount: number;
    eduAmount: number;
    medicalAmount: number;
    splAmount: number;
    conveyanceAmount: number;
    petrolAmount: number;
    shoeAmount: number;
    washingAmount: number;
    uniformAmount: number;
    helperAmount: number;
    productionAmount: number;
    bonusAmount: number;
    messAmount: number;
    othersAmount: number;
    userName: string;
    employeeName: string;
    employeeCode: string;
    employeeType: string;
    employeeCategory: string;
    taAmount: number;
    designation: number;
    department: number;
    unitId: number

    constructor(
        employeeId: number,
        basic: number,
        hraAmount: number,
        eduAmount: number,
        medicalAmount: number,
        splAmount: number,
        conveyanceAmount: number,
        petrolAmount: number,
        shoeAmount: number,
        washingAmount: number,
        uniformAmount: number,
        helperAmount: number,
        productionAmount: number,
        bonusAmount: number,
        messAmount: number,
        othersAmount: number,
        userName: string,
        employeeName: string,
        employeeCode: string,
        employeeType: string,
        employeeCategory: string,
        taAmount: number,
        designation: number,
        department: number,
        unitId: number) {


        this.employeeId = employeeId
        this.basic = basic
        this.hraAmount = hraAmount
        this.eduAmount = eduAmount
        this.medicalAmount = medicalAmount
        this.splAmount = splAmount
        this.conveyanceAmount = conveyanceAmount
        this.petrolAmount = petrolAmount
        this.shoeAmount = shoeAmount
        this.washingAmount = washingAmount
        this.uniformAmount = uniformAmount
        this.helperAmount = helperAmount
        this.productionAmount = productionAmount
        this.bonusAmount = bonusAmount
        this.messAmount = messAmount
        this.othersAmount = othersAmount
        this.userName = userName
        this.employeeName = employeeName
        this.employeeCode = employeeCode
        this.employeeType = employeeType
        this.employeeCategory = employeeCategory
        this.taAmount = taAmount
        this.designation = designation
        this.department = department
        this.unitId = unitId


    }
}